export function isPendingFreshdeskTicket(freshTicket) {
	if (freshTicket === null || freshTicket === undefined || freshTicket === '') {
		return false;
	}

	return String(freshTicket).indexOf('QUEUE-') === 0;
}

export function freshdeskTicketDisplay(freshTicket) {
	if (isPendingFreshdeskTicket(freshTicket)) {
		return 'Pending';
	}

	return freshTicket;
}

export function freshdeskTicketUrl(freshTicket) {
	if (!freshTicket || isPendingFreshdeskTicket(freshTicket)) {
		return null;
	}

	return 'https://karlstechnology.freshdesk.com/helpdesk/tickets/' + freshTicket;
}

/** Value for table CSV export - full Freshdesk URL (or Pending/N/A). */
export function freshdeskTicketExport(freshTicket) {
	if (freshTicket === null || freshTicket === undefined || freshTicket === '') {
		return 'N/A';
	}
	if (isPendingFreshdeskTicket(freshTicket)) {
		return 'Pending';
	}
	return freshdeskTicketUrl(freshTicket);
}
